export const AppActionTypes = {
  Start: "APP_START",
  PropsMatch: "APP_PROPSMATCH",
  Navigate: "APP_NAVIGATE",
  ChangeFeed: "APP_CHANGEFEED",
  Set_Feed: "APP_SET_FEED",
  SetServerTime: "APP_SET_SERVERTIME",
  WindowResize: "APP_WINDOW_RESIZE",
  WindowResizeSet: "APP_WINDOW_RESIZE_SET",
  OpenMobileMenu: "APP_OPEN_MOBILE_MENU",
  OpenMobileBetslip: "APP_OPEN_MOBILE_BETSLIP",
  Set_Avoid_Click: "SET_AVOID_CLICK",
  Switch_mode: "CHANGE_THEME",
};

//Not in use at the moment
export const SignalRTypes = {
  ChangeFeed: "SR_CHANGE_FEED",

  Connect_Request: "SR_CONNECT_REQUEST",
  Connect_Success: "SR_CONNECT_SUCCESS",
  Connect_Error: "SR_CONNECT_ERROR",
  Connect_Slow: "SR_CONNECT_SLOW",

  //Booongo Hub
  Booongo_Connect_Request: "BOOONGO_CONNECT_REQUEST",
  Booongo_Connect_Success: "BOOONGO_CONNECT_SUCCESS",
  Booongo_Connect_Error: "BOOONGO_CONNECT_ERROR",
  Booongo_Connect_Slow: "BOOONGO_CONNECT_SLOW",
  Booongo_Join_Request: "BOOONGO_JOIN_REQUEST",
  Booongo_Join_Response: "BOOONGO_JOIN_RESPONSE",
  Booongo_Part_Request: "BOOONGO_PART_REQUEST",
  Booongo_Part_Response: "BOOONGO_PART_RESPONSE",

  //MemberChange Hub
  Member_Change_Connect_Request: "MEMBER_CHANGE_CONNECT_REQUEST",
  Member_Change_Connect_Success: "MEMBER_CHANGE__CONNECT_SUCCESS",
  Member_Change_Connect_Error: "MEMBER_CHANGE_CONNECT_ERROR",
  Member_Change_Disconnect_Request: "MEMBER_CHANGE_DISCONNECT_REQUEST",
  Member_Change_Disconnect_Success: "MEMBER_CHANGE_DISCONNECT_SUCCESS",
  Member_Change_Update_Balance: "MEMBER_CHANGE_UPDATE_BALANCE",

  //Static Hub
  Static_Connect_Request: "STATIC_CONNECT_REQUEST",
  Static_Connect_Success: "STATIC_CONNECT_SUCCESS",
  Static_Connect_Error: "STATIC_CONNECT_ERROR",
  Static_Connect_Slow: "STATIC_CONNECT_SLOW",
  Static_Connect_Retry: "STATIC_CONNECT_RETRY",

  Static_Disconnect_Request: "STATIC_DISCONNECT_REQUEST",
  Static_Disconnect_Success: "STATIC_DISCONNECT_SUCCESS",

  //Live Hub
  Live_Connect_Request: "LIVE_CONNECT_REQUEST",
  Live_Connect_Success: "LIVE_CONNECT_SUCCESS",
  Live_Connect_Error: "LIVE_CONNECT_ERROR",
  Live_Connect_Slow: "LIVE_CONNECT_SLOW",
  Live_Connect_Retry: "LIVE_CONNECT_RETRY",

  Live_Disconnect_Request: "LIVE_DISCONNECT_REQUEST",
  Live_Disconnect_Success: "LIVE_DISCONNECT_SUCCESS",

  //Virtual Hub
  Virtual_Connect_Request: "VIRTUAL_CONNECT_REQUEST",
  Virtual_Connect_Success: "VIRTUAL_CONNECT_SUCCESS",
  Virtual_Connect_Error: "VIRTUAL_CONNECT_ERROR",
  Virtual_Connect_Slow: "VIRTUAL_CONNECT_SLOW",
  Virtual_Connect_Retry: "VIRTUAL_CONNECT_RETRY",

  Virtual_Disconnect_Request: "VIRTUAL_DISCONNECT_REQUEST",
  Virtual_Disconnect_Success: "VIRTUAL_DISCONNECT_SUCCESS",

  //Spin And Win Hub
  SpinAndWin_Connect_Request: "SPIN_AND_WIN_CONNECT_REQUEST",
  SpinAndWin_Connect_Success: "SPIN_AND_WIN_SUCCESS",
  SpinAndWin_Connect_Error: "SPIN_AND_WIN_ERROR",
  SpinAndWin_Connect_Slow: "SPIN_AND_WIN_SLOW",
  SpinAndWin_Connect_Retry: "SPIN_AND_WIN_RETRY",

  SpinAndWin_Disconnect_Request: "SPIN_AND_WIN_DISCONNECT_REQUEST",
  SpinAndWin_Disconnect_Success: "SPIN_AND_WIN_DISCONNECT_SUCCESS",

  //Lucky Numbers Hub
  LuckyNumbers_Connect_Request: "LUCKY_NUMBERS_CONNECT_REQUEST",
  LuckyNumbers_Connect_Success: "LUCKY_NUMBERS_SUCCESS",
  LuckyNumbers_Connect_Error: "LUCKY_NUMBERS_ERROR",
  LuckyNumbers_Connect_Slow: "LUCKY_NUMBERS_SLOW",
  LuckyNumbers_Connect_Retry: "LUCKY_NUMBERS_RETRY",

  LuckyNumbers_Disconnect_Request: "LUCKY_NUMBERS_DISCONNECT_REQUEST",
  LuckyNumbers_Disconnect_Success: "LUCKY_NUMBERS_DISCONNECT_SUCCESS",

  //Jackpot Hub
  Jackpot_Connect_Request: "JACKPOT_CONNECT_REQUEST",
  Jackpot_Connect_Success: "JACKPOT_CONNECT_SUCCESS",
  Jackpot_Connect_Error: "JACKPOT_CONNECT_ERROR",
  Jackpot_Connect_Slow: "JACKPOT_CONNECT_SLOW",
  Jackpot_Connect_Retry: "JACKPOT_CONNECT_RETRY",
  Jackpot_Member_Connect_Request: "JACKPOT_MEMBER_CONNECT_REQUEST",

  Jackpot_Disconnect_Request: "JACKPOT_DISCONNECT_REQUEST",
  Jackpot_Disconnect_Success: "JACKPOT_DISCONNECT_SUCCESS",

  Jackpot_Join_Request: "JACKPOT_JOIN_REQUEST",
  Jackpot_Join_Response: "JACKPOT_JOIN_RESPONSE",
  Jackpot_Part_Request: "JACKPOT_PART_REQUEST",
  Jackpot_Part_Response: "JACKPOT_PART_RESPONSE",

  Jackpot_Winning_Update: "JACKPOT_WINNING_UPDATE",
  Jackpot_Winning_Update_Join: "JACKPOT_WINNING_UPDATE_JOIN",
  Jackpot_Approval_Update_Request: "JACKPOT_APPROVAL_UPDATE_REQUEST",
  Jackpot_Approval_Update_Success: "JACKPOT_Approval_UPDATE_SUCCESS",

  Jackpot_Balance_Update: "JACKPOT_BALANCE_UPDATE",
  Jackpot_Balance_Success: "JACKPOT_BALANCE_SUCCESS",

  Update_Entity_Balance: "UPDATE_ENTITY_BALANCE",

  Booongo_Disconnect_Request: "BOOONGO_DISCONNECT_REQUEST",
  Booongo_Disconnect_Success: "BOOONGO_DISCONNECT_SUCCESS",

  Disconnect_Request: "SR_DICONNECT_REQUEST",
  Disconnect_Success: "SR_DICONNECT_SUCCESS",

  GetAllData_Response: "SR_GET_ALL_DATA",

  Join_Request: "SR_JOIN_REQUEST",
  Join_Response: "SR_JOIN_RESPONSE",
  Part_Request: "SR_PART_REQUEST",
  Part_Response: "SR_PART_RESPONSE",

  Set_Join_Groups: "SR_SET_JOIN_GROUPS",

  Handle_Join_Part_Groups: "SR_HANDLE_JOIN_PART_GROUPS",

  KironEvent_Request: "SR_KIRONEVENT_REQUEST",
  KironEvent_Response: "SR_KIRONEVENT_RESPONSE",
  KironSportEvents_Request: "SR_KIRONSPORTEVENTS_REQUEST",
  KironSportEvents_Response: "SR_KIRONSPOREVENTS_RESPONSE",

  SportTypes_Init: "SR_SPORTTYPES_INIT",
  SportTypes_Request: "SR_SPORTTYPES_REQUEST",
  SportTypes_Response: "SR_SPORTTYPES_RESPONSE",

  Main_Tournament_Events_Request: "SR_MAIN_TOURNAMENT_EVENTS_REQUEST",
  Main_Tournament_Events_Response: "SR_MAIN_TOURNAMENT_EVENTS_RESPONSE",

  SportCategories_Request: "SR_CATEGORIES_REQUEST",
  SportCategories_Response: "SR_CATEGORIES_RESPONSE",

  SportEvents_Request: "SR_SPORTEVENTS_REQUEST",
  SportEvents_Response: "SR_SPORTEVENTS_RESPONSE",
  SportEvents_Clear: "SR_SPORTEVENTS_Clear",

  TopBets_Request: "SR_TOPBETS_REQUEST",
  TopBets_Response: "SR_TOPBETS_RESPONSE",

  SportEventsVirtual_Request: "SR_SPORTEVENTSVIRTUAL_REQUEST",

  SportEvents_By_Date_Request: "SR_SPORTEVENTS_BY_DATE_REQUEST",
  SportEvents_By_Date_Response: "SR_SPORTEVENTS_BY_DATE_RESPONSE",

  AllBetTypes_Request: "SR_ALL_BETTYPES_REQUEST",
  AllBetTypes_Response: "SR_ALL_BETTYPES_RESPONSE",

  Get_Updated_OddField_Details: "GET_UPDATED_ODD_FIELDS_DETAILS",
  Get_Updated_OddField_Details_Response:
    "GET_UPDATED_ODD_FIELDS_DETAILS_RESPONSE",

  OnFeedChanges: "SR_ONFEEDCHANGED",

  /////
  OnSportEventsChange: "SR_ON_SPORT_EVENTS_CHANGE",
  OnEventOddsChange: "SR_ON_EVENT_ODDS_CHANGE",
  onEventOddGroupsChange: "SR_ON_EVENT_ODD_GROUPS_CHANGE",
  OnEventOddFieldsChange: "SR_ON_EVENT_ODD_FIELDS_CHANGE",
  OnEventScoreChange: "SR_ON_EVENT_SCORE_CHANGE",
  OnSportTournamentsChange: "SR_ON_SPORT_TOURNAMENTS_CHANGE",
  OnTopBetTypesChange: "SR_ON_TOP_BET_TYPES_CHANGE",
  OnSportTypesChange: "SR_ON_SPORT_TYPES_CHANGE",
  OnSportCategoriesChange: "SR_ON_SPORT_CATEGORIES_CHANGE",
  OnSportTopLeaguesChange: "SR_ON_SPORT_TOP_LEAGUES_CHANGE",
  OnUpcomingEventsChange: "SR_ON_UPCOMING_EVENTS_CHANGE",
  OnBarItemsChange: "SR_ON_BAR_ITEMS_CHANGE",
  //////

  OnTimer: "SR_ON_TIMER",
  Re_Connect: "SR_RE_CONNECT",
  Producer_Down: "PRODUCER_DOWN",
  Producer_Up: "PRODUCER_UP",

  By_Day_week_Days_response: "BY_DAY_WEEK_DAYS_RESPONSE",
  Default_Live_Sport_Type_Response: "DEFAULT_LIVE_SPORT_TYPE_RESPONSE",

  OnUpcomingDraws: "On_Upcoming_Draws_Request",
  OnUpcomingDrawsResponse: "On_Upcoming_Draws_Response",
  OnUpcomingDrawsSuccess: "On_Upcoming_Draws_Success",
  OnUpcomingDrawsError: "On_Upcoming_Draws_Error",

  Get_Draws_Categories_And_Tournaments_Request:
    "Get_Draws_Categories_And_Tournaments_Request",
  Get_Draws_Categories_And_Tournaments_Response:
    "Get_Draws_Categories_And_Tournaments_Response",
  Get_Draws_Categories_And_Tournaments_Success:
    "Get_Draws_Categories_And_Tournaments_Success",
  Get_Draws_Categories_And_Tournaments_Error:
    "Get_Draws_Categories_And_Tournaments_Error",

  Get_Lucky_Numbers_Event_Result_Request:
    "Get_Lucky_Numbers_Event_Result_Request",
  Get_Lucky_Numbers_Event_Result_Response:
    "GET_Lucky_Numbers_EVENT_RESULT_RESPONSE",
  Get_Lucky_Numbers_Event_Result_Success:
    "GET_Lucky_Numbers_EVENT_RESULT_SUCCESS",
  Get_Lucky_Numbers_Event_Result_Error: "GET_Lucky_Numbers_EVENT_RESULT_ERROR",

  Reset_upcoming_Draws_And_Result: "Reset_upcoming_Draws_And_Results",

  Get_Draw_Odds_Request: "GET_DRAW_ODDS_REQUEST",
  Get_Draw_Odds_Response: "GET_DRAW_ODDS_RESPONSE",

  Get_Suggested_Balls_Request: "GET_SUGGESTED_BALLS_REQUEST",
  Get_Suggested_Balls_Response: "GET_SUGGESTED_BALLS_RESPONSE",
  Get_Suggested_Balls_Success: "GET_SUGGESTED_BALLS_SUCCESS",
  Get_Suggested_Balls_Error: "GET_SUGGESTED_BALLS_ERROR",

  Connect_to_Banner_Hub: "CONNECT_TO_BANNER_HUB",
  Connect_to_Banner_Hub_Success: "CONNECT_TO_BANNER_HUB_SUCCESS",
  On_Current_Banner_Response: "ON_CURRENT_BANNER_RESPONSE",
  Get_Current_Banner_Request: "GET_CURRENT_BANNER_REQUEST",
  Get_Current_Banner_Success: "GET_CURRENT_BANNER_SUCCESS",
  On_Banner_Change: "ON_BANNER_CHANGE",
  On_Configration_Change: "ON_CONFIGRATION_CHANGE",
  On_Banner_Change_Success: "ON_BANNER_CHANGE_SUCCESS",

  Get_Custom_Bet_Odd_Field_Data_Request:
    "GET_CUSTOM_BET_ODD_FIELD_DATA_REQUEST",
  Get_Custom_Bet_Odd_Field_Data_Success:
    "GET_CUSTOM_BET_ODD_FIELD_DATA_SUCCESS",
  Update_Lucky_Numbers_Favorite: "UPDATE_LUCKY_NUMBER_FAVORITE",
};

export const SearchActionTypes = {
  GetSearchedData_Request: "GET_SEARCHED_DATA_REQUEST",
  GetSearchedData_Response: "GET_SEARCHED_DATA_RESPONSE",
  GetSearchedData_Success: "GET_SEARCHED_DATA_SUCCESS",
  GetSearchedData_Error: "GET_SEARCHED_DATA_ERROR",

  Navigate_Search_Item: "NAVIGATE_SEARCH_ITEM",
};

export const HomeActionTypes = {
  Load_Request: "HOME_LOAD_REQUEST",
};

export const VirtualActionTypes = {
  Load_Request: "VIRTUAL_LOAD_REQUEST",
  SportEvents_Request: "VIRTUAL_SPORTEVENTS_REQUEST",
  SportEvents_Response: "VIRTUAL_SPORTEVENTS_RESPONSE",
};

export const SportActionTypes = {
  Sport_AllEmpty: "SPORT_ALL_EMPTY",
};

export const SportTypesActionTypes = {
  Set_Sport: "SPORT_TYPES_SET_SPORT",
  Init: "SPORT_TYPES_INIT",
  SportTypes_Success: "SPORT_TYPES_SUCCESS",
  SportTypes_Error: "SPORT_TYPES_ERROR",
  Main_Tournament_Events_Success: "MAIN_TOURNAMENT_EVENTS_SUCCESS",
  Main_Tournament_Events_Error: "MAIN_TOURNAMENT_EVENTS_ERROR",

  SportTypes_Remove_Disabled: "SPORT_TYPES_REMOVE_DISABLED",
};

export const CategoriesActionTypes = {
  Set_Tournament: "CATEGORIES_SET_TOURNAMENT",
  Init: "CATEGORIES_INIT",
  SportCategories_Success: "CATEGORIES_SUCCESS",
  SportCategories_Error: "CATEGORIES_ERROR",
  SportTopLeagues_Success: "TOP_LEAGUES_SUCCESS",

  SportCategories_Remove_Disabled: "SPORT_TYPES_REMOVE_DISABLED",

  Update_Favorite_Country_For_Sport_Category:
    "UPDATE_FAVORITE_COUNTRY_FOR_SPORT_CATEGORY",
};

export const SportEventsActionTypes = {
  Set_Event: "SPORT_EVENTS_SET_EVENT",
  Init: "SPORT_EVENTS_INIT",

  SportEvents_Success: "SPORT_EVENTS_SUCCESS",
  SportEvents_Error: "SPORT_EVENTS_ERROR",

  SportEvents_OddFields_Success: "SPORT__ODDFIELDS_EVENTS_SUCCESS",

  SportEvents_Odds_Success: "SPORT_ODDS_EVENTS_SUCCESS",
  SportEvents_Events_FeedChange: "SPORT_EVENTS_FEEDCHANGE",
  SportEvents_Upcoming_Events_Success: "SPORT_UPCOMING_EVENTS_SUCCESS",
  SportEvents_Groups_Success: "SPORT_GROUPS_SUCCESS",
  SportEvents_BetTypes_Success: "SPORT_BETTYPES_SUCCESS",

  AllBetTypes_Success: "SPORT_EVENTS_ALL_BETTYPES_SUCCESS",
  AllBetTypes_Error: "SPORT_EVENTS_ALL_BETTYPES_ERROR",

  SportEvents_Update: "SPORT_EVENTS_UPDATE",
  SportEvents_OnDropDownsChange: "SPORT_EVENTS_ON_DROPDOWNS_CHANGE",
  SportEvents_OnMobileBetFilterClick: "SPORT_EVENTS_On_Mobile_Bet_FilterClick",

  Sport_Get_Week_Match_Days_Request: "SPORT_GET_WEEK_MATCH_DAYS_REQUEST",
  Sport_Get_Week_Match_Days_Success: "SPORT_GET_WEEK_MATCH_DAYS_SUCCESS",
  Sport_Get_Week_Match_Days_Error: "SPORT_GET_WEEK_MATCH_DAYS_ERROR",

  Get_Default_Live_Sport_Type_Request: "GET_DEFAULT_LIVE_SPORT_TYPE_REQUEST",
  Get_Default_Live_Sport_Type_Success: "GET_DEFAULT_LIVE_SPORT_TYPE_SUCCESS",
  Get_Default_Live_Sport_Type_Error: "GET_DEFAULT_LIVE_SPORT_TYPE_ERROR",

  Filter_Sport_Events_Action: "FILTER_SPORT_EVENTS_ACTION",

  Update_Favorite_Sport_Events: "UPDATE_FAVORITE_SPORT_EVENTS",
  Update_Favorite_Team_For_Sport_Events:
    "UPDATE_FAVORITE_TEAM_FOR_SPORT_EVENTS",
  Update_Favorite_Country_For_Sport_Events:
    "UPDATE_FAVORITE_COUNTRY_FOR_SPORT_EVENTS",
};

export const LiveActionTypes = {
  Load_Request: "LIVE_LOAD_REQUEST",
};

export const GeneralActionTypes = {
  //GET THE MAP DATA
  Map_Request: "MAP_REQUEST",
  Map_Success: "MAP_SUCCESS",
  Map_Error: "MAP_ERROR",

  Form_Statuses_Request: "FORM_STATUSES_REQUEST",
  Form_Statuses_Success: "FORM_STATUSES_SUCCESS",
  Form_Statuses_Error: "FORM_STATUSES_ERROR",

  Bet_Slip_Configuration_Request: "BET_SLIP_CONFIGURATION_REQUEST",
  Bet_Slip_Configuration_Success: "BET_SLIP_CONFIGURATION_SUCCESS",
  Bet_Slip_Configuration_Error: "BET_SLIP_CONFIGURATION_ERROR",

  Page_Name_Request: "PAGE_NAME_REQUEST",
  Page_Name_Success: "PAGE_NAME_SUCCESS",
  Page_Name_Error: "PAGE_NAME_ERROR",

  Web_Files_Request: "WEB_FILES_REQUEST",
  Web_Files_Success: "WEB_FILES_SUCCESS",
  Web_Files_Error: "WEB_FILES_ERROR",

  Web_File_Request: "WEB_FILE_REQUEST",
  Web_File_Response: "WEB_FILE_RESPONSE",

  Bets_By_Bet_Code_Request: "BETS_BY_BET_CODE_REQUEST",
  Bets_By_Bet_Code_Success: "BETS_BY_BET_CODE_SUCCESS",
  Bets_By_Bet_Code_Error: "BETS_BY_BET_CODE_ERROR",

  Create_Bet_Code_Request: "CREATE_BET_CODE_REQUEST",
  Create_Bet_Code_Success: "CREATE_BET_CODE_SUCCESS",
  Create_Bet_Code_Error: "CREATE_BET_CODE_ERROR",
  Bet_Code_Clear: "BET_CODE_CLEAR",

  Get_DrillDown_Groups_Request: "GET_DRILLDOWN_GROUPS_REQUEST",
  Get_DrillDown_Groups_Success: "GET_DRILLDOWN_GROUPS_SUCCESS",
  Get_DrillDown_Groups_Error: "GET_DRILLDOWN_GROUPS_ERROR",

  Get_Configuration_Request: "GET_CONFIGURATION_REQUEST",
  Get_Configuration_Success: "GET_CONFIGURATION_SUCCESS",
  Get_Configuration_Error: "GET_CONFIGURATION_ERROR",

  Get_Currencies_Request: "GET_CURRENCIES_REQUEST",
  Get_Currencies_Success: "GET_CURRENCIES_SUCCESS",
  Get_Currencies_Error: "GET_CURRENCIES_ERROR",

  Get_CountryPhone_Providers_Request: "GET_COUNTRYPHONE_PROVIDERS_REQUEST",
  Get_CountryPhone_Providers_Success: "GET_COUNTRYPHONE_PROVIDERS_SUCCESS",
  Get_CountryPhone_Providers_Error: "GET_COUNTRYPHONE_PROVIDERS_ERROR",

  Get_Countries_Request: "GET_COUNTRIES_REQUEST",
  Get_Countries_Success: "GET_COUNTRIES_SUCCESS",
  Get_Countries_Error: "GET_COUNTRIES_ERROR",

  Get_Counties_Request: "GET_COUNTIES_REQUEST",
  Get_Counties_Success: "GET_COUNTIES_SUCCESS",
  Get_Counties_Error: "GET_COUNTIES_ERROR",

  Get_Banners_Request: "GET_BANNERS_REQUEST",
  Get_Banners_Success: "GET_BANNERS_SUCCESS",
  Get_Banners_Error: "GET_BANNERS_ERROR",

  Get_Calender_Request: "GET_CALENDER_REQUEST",
  Get_Calender_Success: "GET_CALENDER_SUCCESS",
  Get_Calender_Error: "GET_CALENDER_ERROR",

  Get_Footer_Providers_Request: "GET_FOOTER_PROVIDERS_REQUEST",
  Get_Footer_Providers_Success: "GET_FOOTER_PROVIDERS_SUCCESS",
  Get_Footer_Providers_Error: "GET_FOOTER_PROVIDERS_ERROR",

  Get_Footer_Text_Request: "GET_FOOTER_TEXT_REQUEST",
  Get_Footer_Text_Success: "GET_FOOTER_TEXT_SUCCESS",
  Get_Footer_Text_Error: "GET_FOOTER_TEXT_ERROR",

  Server_Time: "SERVER_TIME",

  Get_Country_Flag_Images: "GET_COUNTRY_FLAG_IMAGES",
  Get_Country_Flag_Images_Success: "GET_COUNTRY_FLAG_IMAGES_SUCCESS",
  Get_Country_Flag_Images_Error: "GET_COUNTRY_FLAG_IMAGES_ERROR",

  Validate_Coupon_Request: "VALIDATE_COUPON_REQUEST",
  Validate_Coupon_Success: "VALIDATE_COUPON_SUCCESS",
  Validate_Coupon_Reset: "VALIDATE_COUPON_RESET",
  Validate_Coupon_Error: "VALIDATE_COUPON_ERROR",
  Validate_Coupon_Clear_Message: "VALIDATE_COUPON_CLEAR_MESSAGE",
  Coupon_Reset: "COUPON_RESET",

  Get_Loyalty_Rewards_Options_Request: "GET_LOYALITY_REWARDS_OPTIONS_REQUEST",
  Get_Loyalty_Rewards_Options_Success: "GET_LOYALITY_REWARDS_OPTIONS_SUCCESS",
  Get_Loyalty_Rewards_Options_Error: "GET_LOYALITY_REWARDS_OPTIONS_ERROR",

  Get_Sport_Promos_Request: "GET_SPORT_PROMOS_REQUEST",
  Get_Sport_Promos_Suceess: "GET_SPORT_PROMOS_SUCCESS",
  Get_Sport_Promos_Error: "GET_SPORT_PROMOS_ERROR",

  Get_Sport_Promos_Info_Request: "GET_SPORT_PROMOS_INFO_REQUEST",
  Get_Sport_Promos_Info_Suceess: "GET_SPORT_PROMOS_INFO_SUCCESS",
  Get_Sport_Promos_Info_Error: "GET_SPORT_PROMOS_INFO_ERROR",

  Reset_Get_Sport_Promos_Info_Request: "RESET_GET_SPORT_PROMOS_INFO_REQUEST",
  Reset_Get_Sport_Promos: "RESET_GET_SPORT_PROMOS",

  Get_Header_Tabs_Request: "GET_HEADER_TABS_REQUEST",
  Get_Header_Tabs_Success: "GET_HEADER_TABS_SUCCESS",
  Get_Header_Tabs_Error: "GET_HEADER_TABS_ERROR",

  Get_Sport_Types_Icons_Request: "GET_SPORT_TYPE_ICONS_REQUEST",
  Get_Sport_Types_Icons_Success: "GET_SPORT_TYPE_ICONS_SUCCESS",
  Get_Sport_Types_Icons_Error: "GET_SPORT_TYPE_ICONS_ERROR",

  Active_Spin_And_Win_Table: "ACTIVE_SPIN_AND_WIN_TABLE",

  Get_Lucky_Number_Configuration_Request:
    "GET_LUCKY_NUMBER_CONFIGRATION_REQUEST",
  Get_Lucky_Number_Configuration_Success:
    "GET_LUCKY_NUMBER_CONFIGRATION_SUCCESS",
  Get_Lucky_Number_Configuration_Error: "GET_LUCKY_NUMBER_CONFIGRATION_ERROR",

  Get_Landing_Configuration_Request: "GET_LANDING_CONFIGRATION_REQUEST",
  Get_Landing_Configuration_Success: "GET_LANDING_CONFIGRATION_SUCCESS",
  Get_Landing_Configuration_Error: "GET_LANDING_CONFIGRATION_ERROR",

  Get_Work_With_Us_Configuration_Request:
    "GET_WORK_WITH_US_CONFIGRATION_REQUEST",
  Get_Work_With_Us_Configuration_Success:
    "GET_WORK_WITH_US_CONFIGRATION_SUCCESS",
  Get_Work_With_Us_Configuration_Error: "GET_WORK_WITH_US_CONFIGRATION_ERROR",

  Get_Kiosk_Web_Banner_Images_Request: "GET_KIOSK_WEB_BANNER_IMAGES_REQUEST",
  Get_Kiosk_Web_Banner_Images_Success: "GET_KIOSK_WEB_BANNER_IMAGES_SUCCESS",
  Get_Kiosk_Web_Banner_Images_Error: "GET_KIOSK_WEB_BANNER_IMAGES_ERROR",

  Get_Sports_SideBar_Request: "GET_SPORTS_SIDEBAR_REQUEST",
  Get_Sports_SideBar_Success: "GET_SPORTS_SIDEBAR_SUCCESS",
  Get_Sports_SideBar_Error: "GET_SPORTS_SIDEBAR_ERROR",
};

export const ContactUsActionTypes = {
  // GET THE SUBJECTS
  Subjects_Request: "SUBJECTS_REQUEST",
  Subjects_Success: "SUBJECTS_SUCCESS",
  Subjects_Error: "SUBJECT_ERROR",

  Contact_Data_Request: "CONTACT_DATA_REQUEST",
  Contact_Data_Success: "CONTACT_DATA_SUCCESS",
  Contact_Data_Error: "CONTACT_DATA_ERROR",
};

export const RegisterActionTypes = {
  Init: "INIT_REGISTER",
  //Get Register Entites
  Register_Entities_Request: "REGISTER_ENTITIES_REQUEST",
  Register_Entities_Success: "REGISTER_ENTITIES_SUCCESS",
  Register_Entities_Error: "REGISTER_ENTITIES_ERROR",

  Verify_Email_Request: "VERIFY_EMAIL_REQUEST",
  Verify_Email_Success: "VERIFY_EMAIL_SUCCESS",
  Verify_Email_Error: "VERIFY_EMAIL_ERROR",

  Add_Member_Phone_Request: "ADD_MEMBER_PHONE_REQUEST",
  Add_Member_Phone_Success: "ADD_MEMBER_PHONE_SUCCESS",
  Add_Member_Phone_Error: "ADD_MEMBER_PHONE_ERROR",

  //Validate Phone
  Validate_Phone_Request: "VALIDATE_PHONE_REQUEST",
  Validate_Phone_Success: "VALIDATE_PHONE_SUCCESS",
  Validate_Phone_Error: "VALIDATE_PHONE_ERROR",

  //Validate add phone
  Validate_Add_Phone_Request: "VALIDATE_ADD_PHONE_REQUEST",
  Validate_Add_Phone_Success: "VALIDATE_ADD_PHONE_SUCCESS",
  Validate_Add_Phone_Error: "VALIDATE_ADD_PHONE_ERROR",

  //Register member
  Register_Member_Request: "REGISTER_MEMBER_REQUEST",
  Register_Member_Success: "REGISTER_MEMBER_SUCCESS",
  Register_Member_Error: "REGISTER_MEMBER_ERROR",

  // VALIDATE EMAIL
  Validate_Email_Request: "VALIDATE_EMAIL_RESPONSE",
  Validate_Email_Success: "VALIDATE_EMAIL_SUCCESS",
  Validate_Email_Error: "VALIDATE_EMAIL_ERROR",

  Send_Register_Data: "SEND_REGISTER_DATA",
  Handle_Register_signin: "HANDLE_REGISTER_SIGNIN",
};

export const AuthActionTypes = {
  Init: "INIT_AUTH",
  //Sign In
  Signin_Request: "SIGNIN_REQUEST",
  Signin_Success: "SIGNIN_SUCCESS",
  Register_Signin_Success: "REGISTER_SIGNIN_SUCCESS",
  Signin_Error: "SIGNIN_ERROR",

  //Sign Out
  Signout_Request: "SIGNOUT_REQUEST",
  Signout_Success: "SIGNOUT_SUCCESS",
  Signout_Error: "SIGNOUT_ERROR",

  Forgot_Password_Check_Dest_Request: "FORGOT_PASSWORD_CHECK_DEST_REQUEST",
  Forgot_Password_Check_Dest_Suceess: "FORGOT_PASSWORD_CHECK_DEST_SUCCESS",
  Forgot_Password_Check_Dest_Error: "FORGOT_PASSWORD_CHECK_DEST_ERROR",

  Forgot_Password_Request: "FORGOT_PASSWORD_REQUEST",
  Forgot_Password_Suceess: "FORGOT_PASSWORD_SUCCESS",
  Forgot_Password_Error: "FORGOT_PASSWORD_ERROR",

  Forgot_Password_Confirm_Request: "FORGOT_PASSWORD_CONFIRM_REQUEST",
  Forgot_Password_Confirm_Suceess: "FORGOT_PASSWORD_CONFIRM_SUCCESS",
  Forgot_Password_First_Step_Confirm_Suceess:
    "FORGOT_PASSWORD_FIRST_STEP_CONFIRM_SUCCESS",
  Forgot_Password_Confirm_Error: "FORGOT_PASSWORD_CONFIRM_ERROR",

  Change_Password_Request: "CHANGE_PASSWORD_REQUEST",
  Change_Password_Suceess: "CHANGE_PASSWORD_SUCCESS",
  Change_Password_Error: "CHANGE_PASSWORD_ERROR",

  Update_Password_Request: "UPDATE_PASSWORD_REQUEST",
  Update_Password_Suceess: "UPDATE_PASSWORD_SUCCESS",
  Update_Password_Error: "UPDATE_PASSWORD_ERROR",

  Start_Click_listener: "START_CLICK_LISTENER",
  Set_Show_Login_Pop_Confirm: "SET_SHOW_LOGIN_POP_CONFIRM",

  // Token
  Refresh_Token_Request: "REFRESH_TOKEN_REQUEST",
  Refresh_Token_Success: "REFRESH_TOKEN_SUCCESS",
  Refresh_Token_Error: "REFRESH_TOKEN_ERROR",
};

export const MembersActionTypes = {
  Init: "INIT_MEMBER",
  //Update member phone
  Add_Second_Member_Phone_Request: "ADD_SECOND_MEMBER_PHONE_REQUEST",
  Add_Second_Member_Phone_Success: "ADD_SECOND_MEMBER_PHONE_SUCCESS",
  Add_Second_Member_Phone_Error: "ADD_SECOND_MEMBER_PHONE_ERROR",

  //Validate add phone
  Validate_Add_Second_Phone_Request: "VALIDATE_SECOND_ADD_PHONE_REQUEST",
  Validate_Add_Second_Phone_Success: "VALIDATE_SECOND_ADD_PHONE_SUCCESS",
  Validate_Add_Second_Phone_Error: "VALIDATE_SECOND_ADD_PHONE_ERROR",

  // Update Member Details
  Member_Details_Request: "MEMBER_DETAILS_REQUEST",
  Member_Details_Success: "MEMBER_DETAILS_SUCCESS",
  Member_Details_Error: "MEMBER_DETAILS_ERROR",

  // Get Member Details
  Get_Member_Details_Request: "GET_MEMBER_DETAILS_REQUEST",
  Get_Member_Details_Success: "GET_MEMBER_DETAILS_SUCCESS",
  Get_Member_Details_Error: "GET_MEMBER_DETAILS_ERROR",

  Send_Verify_Email_Request: "SEND_VERIFY_EMAIL_REQUEST",
  Send_Verify_Email_Success: "SEND_VERIFY_EMAIL_SUCCESS",
  Send_Verify_Email_Error: "SEND_VERIFY_EMAIL_ERROR",

  Deposit_From_Voucher_Request: "DEPOSIT_FROM_VOUCHER_REQUEST",
  Deposit_From_Voucher_Success: "DEPOSIT_FROM_VOUCHER_SUCCESS",
  Deposit_From_Voucher_Error: "DEPOSIT_FROM_VOUCHER_ERROR",

  Mtn_Deposit_Request: "MTN_DEPOSIT_REQUEST",
  Mtn_Deposit_Success: "MTN_DEPOSIT_SUCCESS",
  Mtn_Deposit_Error: "MTN_DEPOSIT_ERROR",

  Orange_Deposit_Request: "ORANGE_DEPOSIT_REQUEST",
  Orange_Deposit_Success: "ORANGE_DEPOSIT_SUCCESS",
  Orange_Deposit_Error: "ORANGE_DEPOSIT_ERROR",

  Mtn_Withdraw_Request: "MTN_WITHDRAW_REQUEST",
  Mtn_Withdraw_Success: "MTN_WITHDRAW_SUCCESS",
  Mtn_Withdraw_Error: "MTN_WITHDRAW_ERROR",

  Tipme_Withdraw_Request: "TIPME_WITHDRAW_REQUEST",
  Tipme_Withdraw_Success: "TIPME_WITHDRAW_SUCCESS",
  Tipme_Withdraw_Error: "TIPME_WITHDRAW_ERROR",

  Tipme_Confirm_Withdraw_Request: "TIPME_CONFIRM_WITHDRAW_REQUEST",
  Tipme_Confirm_Withdraw_Success: "TIPME_CONFIRM_WITHDRAW_SUCCESS",
  Tipme_Confirm_Withdraw_Error: "TIPME_CONFIRM_WITHDRAW_ERROR",

  Orange_Withdraw_Request: "ORANGE_WITHDRAW_REQUEST",
  Orange_Withdraw_Success: "ORANGE_WITHDRAW_SUCCESS",
  Orange_Withdraw_Error: "ORANGE_WITHDRAW_ERROR",

  Withdrawal_To_Voucher_Request: "WITHDRAWAL_TO_VOUCHER_REQUEST",
  Withdrawal_To_Voucher_Success: "WITHDRAWAL_TO_VOUCHER_SUCCESS",
  Withdrawal_To_Voucher_Error: "WITHDRAWAL_TO_VOUCHER_ERROR",

  Member_Transactions_Request: "MEMBER_TRANSTACTIONS_REQUEST",
  Member_Transactions_Success: "MEMBER_TRANSTACTIONS_SUCCESS",
  Member_Transactions_Error: "MEMBER_TRANSTACTIONS_ERROR",

  Member_Forms_Request: "MEMBER_FORMS_REQUEST",
  Member_Forms_Success: "MEMBER_FORMS_SUCCESS",
  Member_Forms_Error: "MEMBER_FORMS_ERROR",

  Member_Forms_Change: "MEMBER_FORMS_CHANGE",

  Forms_Details_Request: "FORMS_DETAILS_REQUEST",
  Forms_Details_Success: "FORMS_DETAILS_SUCCESS",
  Forms_Details_Error: "FORMS_DETAILS_ERROR",

  Add_Provider_List_Request: "ADD_PROVIDER_LIST_REQUEST",
  Add_Provider_List_Success: "ADD_PROVIDER_LIST_Success",
  Add_Provider_List_Error: "ADD_PROVIDER_LIST_Error",

  Member_Add_Provider_List_Request: "MEMBER_ADD_PROVIDER_LIST_REQUEST",
  Member_Add_Provider_List_Success: "MEMBER_ADD_PROVIDER_LIST_Success",
  Member_Add_Provider_List_Error: "MEMBER_ADD_PROVIDER_LIST_Error",

  Tip_Me_Customer_Search_Request: "TIP_ME_CUSTOMER_SEARCH_REQUEST",
  Tip_Me_Customer_Search_Success: "TIP_ME_CUSTOMER_SEARCH_SUCCESS",
  Tip_Me_Customer_Search_Error: "TIP_ME_CUSTOMER_SEARCH_ERROR",

  Deposite_Tip_Me_Customer_Search_Request:
    "DEPOSITE_TIP_ME_CUSTOMER_SEARCH_REQUEST",
  Deposite_Tip_Me_Customer_Search_Success:
    "DEPOSITE_TIP_ME_CUSTOMER_SEARCH_SUCCESS",
  Deposite_Tip_Me_Customer_Search_Error:
    "DEPOSITE_TIP_ME_CUSTOMER_SEARCH_ERROR",

  Tip_Me_First_Deposit_Message_Request: "TIP_ME_FIRST_DEPOSIT_MESSAGE_REQUEST",
  Tip_Me_First_Deposit_Message_Success: "TIP_ME_FIRST_DEPOSIT_MESSAGE_SUCCESS",
  Tip_Me_First_Deposit_Message_Error: "TIP_ME_FIRST_DEPOSIT_MESSAGE_ERROR",

  Tip_Me_OTP_Verification_Request: "TIP_ME_OTP_VERIFICATION_REQUEST",
  Tip_Me_OTP_Verification_Success: "TIP_ME_OTP_VERIFICATION_SUCCESS",
  Tip_Me_OTP_Verification_Error: "TIP_ME_OTP_VERIFICATION_ERROR",

  Add_Member_Providers_Request: "ADD_MEMBER_PROVIDERS_REQUEST",
  Add_Member_Providers_Success: "ADD_MEMBER_PROVIDERS_SUCCESS",
  Add_Member_Providers_Error: "ADD_MEMBER_PROVIDERS_ERROR",

  Get_Rewards_Request: "GET_REWARDS_REQUEST",
  Get_Rewards_Success: "GET_REWARDS_SUCCESS",
  Get_Rewards_Error: "GET_REWARDS_ERROR",

  Get_Rewards_Transaction_Request: "GET_REWARDS_TRANSACTION_REQUEST",
  Get_Rewards_Transaction_Success: "GET_REWARDS_TRANSACTION_SUCCESS",
  Get_Rewards_Transaction_Error: "GET_REWARDS_TRANSACTION_ERROR",

  Get_Club_Reward_Status_Request: "GET_CLUB_REWARD_STATUS_REQUEST",
  Get_Club_Reward_Status_Success: "GET_CLUB_REWARD_STATUS_SUCCESS",
  Get_Club_Reward_Status_Error: "GET_CLUB_REWARD_STATUS_ERROR",

  Get_Club_Member_Reward_Info_Request: "GET_CLUB_MEMBER_REWARD_INFO_REQUEST",
  Get_Club_Member_Reward_Info_Success: "GET_CLUB_MEMBER_REWARD_INFO_SUCCESS",
  Get_Club_Member_Reward_Info_Error: "GET_CLUB_MEMBER_REWARD_INFO_ERROR",

  Customer_Club_Reward_Redeem_Request: "CUSTOMER_CLUB_REWARD_REDEEM_REQUEST",
  Customer_Club_Reward_Redeem_Success: "CUSTOMER_CLUB_REWARD_REDEEM_SUCCESS",
  Customer_Club_Reward_Redeem_Error: "CUSTOMER_CLUB_REWARD_REDEEM_ERROR",

  Get_Wheel_Of_Fortune_Gift_Request: "GET_WHEEL_OF_FORTUNE_GIFT_REQUEST",
  Get_Wheel_Of_Fortune_Gift_Success: "GET_WHEEL_OF_FORTUNE_GIFT_SUCCESS",
  Get_Wheel_Of_Fortune_Gift_Error: "GET_WHEEL_OF_FORTUNE_GIFT_ERROR",

  Wheel_Of_Fortune_Spin_Request: "WHEEL_OF_FORTUNE_SPIN_REQUEST",
  Wheel_Of_Fortune_Spin_Success: "WHEEL_OF_FORTUNE_SPIN_SUCCESS",
  Wheel_Of_Fortune_Spin_Error: "WHEEL_OF_FORTUNE_SPIN_ERROR",

  Voucher_Details_Request: "VOUCHER_DETAILS_REQUEST",
  Voucher_Details_Success: "VOUCHER_DETAILS_SUCCESS",
  Voucher_Details_Error: "VOUCHER_DETAILS_ERROR",

  Skip: "SKIP",
  Previous: "PREVIOUS",

  Member_Update_Balance: "MEMBER_UPDATE_BALANCE",

  Set_Selected_Currency: "SET_SELECTED_CURRENCY",

  Member_Approved_Jackpot_Winnings_Request:
    "MEMBER_APPROVED_JACKPOT_WINNING_REQUEST",
  Member_Approved_Jackpot_Winnings_Success:
    "MEMBER_APPROVED_JACKPOT_WINNING_SUCCESS",
  Member_Approved_Jackpot_Winnings_Error:
    "MEMBER_APPROVED_JACKPOT_WINNING_ERROR",
  Open_Mobile_Table_Details: "OPEN_MOBILE_TABLE_DETAILS",
  Open_Mobile_Voucher_Details: "OPEN_MOBILE_VOUCHER_DETAILS",
  Open_Bet_Details_Modal: "OPEN_BET_DETAILS_MODAL",
  Open_Reward_Spin_Modal: "OPEN_REWARD_SPIN_MODAL",
  Open_Voucher_Modal: "OPEN_VOUCHER_MODAL",

  CheckDepositBonusConditions_Request: "CHECK_DEPOSIT_BONUS_CONDITIONS_REQUEST",
  CheckDepositBonusConditions_Success: "CHECK_DEPOSIT_BONUS_CONDITIONS_SUCCESS",
  CheckDepositBonusConditions_Error: "CHECK_DEPOSIT_BONUS_CONDITIONS_ERROR",

  CreateCustomerServiceCode_Request: "CREATE_CUSTOMER_SERVICE_CODE_REQUEST",
  CreateCustomerServiceCode_Success: "CREATE_CUSTOMER_SERVICE_CODE_SUCCESS",
  CreateCustomerServiceCode_Error: "CREATE_CUSTOMER_SERVICE_CODE_ERROR",

  Get_Sign_In_Loyalty_Rewards_Options_Request:
    "GET_SIGN_IN_LOYALITY_REWARDS_OPTIONS_REQUEST",

  Get_Loyalty_Rewards_Coupons_Request: "GET_LOYALITY_REWARDS_COUPONS_REQUEST",
  Get_Loyalty_Rewards_Coupons_Success: "GET_LOYALITY_REWARDS_COUPONS_SUCCESS",
  Get_Loyalty_Rewards_Coupons_Error: "GET_LOYALITY_REWARDS_COUPONS_ERROR",

  Create_Member_Slots_Bonus_Request: "CREATE_MEMBER_SLOTS_BONUS_REQUEST",
  Create_Member_Slots_Bonus_Success: "CREATE_MEMBER_SLOTS_BONUS_SUCCESS",
  Create_Member_Slots_Bonus_Error: "CREATE_MEMBER_SLOTS_BONUS_ERROR",

  Reset_Single_Reward: "REST_SINGLE_REWARD",

  Get_Last_Reward_Notifications_Request:
    "GET_LAST_REWARD_NOTIFICATIONS_REQUEST",
  Get_Last_Reward_Notifications_Success:
    "GET_LAST_REWARD_NOTIFICATIONS_SUCCESS",
  Get_Last_Reward_Notifications_Error: "GET_LAST_REWARD_NOTIFICATIONS_ERROR",

  Get_Notification_History_Request: "GET_NOTIFICATION_HISTORY_REQUEST",
  Get_Notification_History_Success: "GET_NOTIFICATION_HISTORY_SUCCESS",
  Get_Notification_History_Error: "GET_NOTIFICATION_HISTORY_ERROR",

  Delete_Notification_Request: "DELETE_NOTIFICATION_REQUEST",
  Delete_Notification_Success: "DELETE_NOTIFICATION_SUCCESS",
  Delete_Notification_Error: "DELETE_NOTIFICATION_ERROR",

  Get_Notification_Count_Request: "GET_NOTIFICATION_COUNT_REQUEST",
  Get_Notification_Count_Success: "GET_NOTIFICATION_COUNT_SUCCESS",
  Get_Notification_Count_Error: "GET_NOTIFICATION_COUNT_ERROR",

  Mute_Notification_Request: "MUTE_NOTIFICATION_REQUEST",
  Mute_Notification_Success: "MUTE_NOTIFICATION_SUCCESS",
  Mute_Notification_Error: "MUTE_NOTIFICATION_ERROR",

  Get_Form_Cash_Out_Offer_Request: "GET_FORM_CASH_OUT_OFFER_REQUEST",
  Get_Form_Cash_Out_Offer_Success: "GET_FORM_CASH_OUT_OFFER_SUCCESS",
  Get_Form_Cash_Out_Offer_Error: "GET_FORM_CASH_OUT_OFFER_ERROR",

  Early_Cash_Out_Request: "EARLY_CASH_OUT_REQUEST",
  Early_Cash_Out_Success: "EARLY_CASH_OUT_SUCCESS",
  Early_Cash_Out_Error: "EARLY_CASH_OUT_ERROR",

  Set_Member_Cash_Out_Offer: "SET_MEMBER_CASH_OUT_OFFER",
  Reset_Member_Cash_Out_Offer: "RESET_MEMBER_CASH_OUT_OFFER",

  Get_Notification_Details_Request: "GET_NOTIFICATION_DETAILS_REQUEST",
  Get_Notification_Details_Success: "GET_NOTIFICATION_DETAILS_SUCCESS",
  Get_Notification_Details_Error: "GET_NOTIFICATION_DETAILS_ERROR",

  Read_Notification_Status_Request: "READ_NOTIFICATION_STATUS_REQUEST",
  Read_Notification_Status_Success: "READ_NOTIFICATION_STATUS_SUCCESS",
  Read_Notification_Status_Error: "READ_NOTIFICATION_STATUS_ERROR",

  Manage_Memeber_Favorite_Request: "MANAGE_MEMBER_FAVORITE_REQUEST",
  Manage_Memeber_Favorite_Success: "MANAGE_MEMBER_FAVORITE_SUCCESS",
  Manage_Memeber_Favorite_Error: "MANAGE_MEMBER_FAVORITE_ERROR",

  Create_Member_Slots_Bonus_By_Coupon_Code_Request:
    "CREATE_MEMBER_SLOTS_BONUS_BY_COUPON_CODE_REQUEST",
  Create_Member_Slots_Bonus_By_Coupon_Code_Success:
    "CREATE_MEMBER_SLOTS_BONUS_BY_COUPON_CODE_SUCCESS",
  Create_Member_Slots_Bonus_By_Coupon_Code_Error:
    "CREATE_MEMBER_SLOTS_BONUS_BY_COUPON_CODE_ERROR",

  Create_Virtual_Sport_Token_Request: "CREATE_VIRTUAL_SPORT_TOKEN_REQUEST",
  Create_Virtual_Sport_Token_Success: "CREATE_VIRTUAL_SPORT_TOKEN_SUCCESS",
  Create_Virtual_Sport_Token_Error: "CREATE_VIRTUAL_SPORT_TOKEN_ERROR",

  Get_Virtuals_Sport_Menu_Request: "GET_VIRTUALS_SPORT_MENU_REQUEST",
  Get_Virtuals_Sport_Menu_Success: "GET_VIRTUALS_SPORT_MENU_SUCCESS",
  Get_Virtuals_Sport_Menu_Error: "GET_VIRTUALS_SPORT_MENU_ERROR",

  Set_Virtual_Sport_Iframe_Url: "SET_VIRTUAL_SPORT_IFRAME_URL",
  Reset_Virtual_Sport_Iframe_Url: "RESET_VIRTUAL_SPORT_IFRAME_URL",

  Get_Members_Games_Request: "GET_MEMBERS_GAMES_REQUEST",
  Get_Members_Games_Success: "GET_MEMBERS_GAMES_SUCCESS",
  Get_Members_Games_Error: "GET_MEMBERS_GAMES_ERROR",

  Get_Member_Balance_Request: "GET_MEMBER_BALANCE_REQUEST",
  Get_Member_Balance_Success: "GET_MEMBER_BALANCE_SUCCESS",
  Get_Member_Balance_Error: "GET_MEMBER_BALANCE_ERROR",
};

export const BetSlipActionTypes = {
  Update_BetSlip_List_Request: "UPDATE_BETSLIP_LIST_REQUEST",
  Update_BetSlip_List_Done: "UPDATE_BETSLIP_LIST_DONE",
  Update_BetSlip_From_Storage: "UPDATE_BETSLIP_FROM_STORAGE",

  Update_BetSlip_From_FeedChange: "UPDATE_BETSLIP_FROM_FEEDCHANGE",

  Set_Tab: "SET_TAB",
  BetSlip_Clear: "BETSLIP_CLEAR",
  Clear_Succeeded_Bets: "CLEAR_SUCCEEDED_BETS",
  BetSlip_Remove_Field: "BETSLIP_REMOVE_FIELD",

  On_Amount_Change: "ON_AMOUNT_CHANGE",
  On_Field_Amount_Change: "ON_FIELD_AMOUNT_CHANGE",

  Place_Multiple_Bet_Request: "PLACE_MULTIPLE_BET_REQUEST",
  Place_Single_Bet_Request: "PLACE_SINGLE_BET_REQUEST",
  Place_Bet_Success: "PLACE_BET_SUCCESS",
  Place_Bet_Builder_Success: "PLACE_BET_BUILDER_SUCCESS",
  Place_Bet_Error: "PLACE_BET_ERROR",
  Place_Single_Bets_Response: "PLACE_SINGLE_BETS_RESPONSE",

  Set_BetSlip_Errors: "SET_BETSLIP_ERRORS",
  Set_BetSlip_Total_Odds: "SET_BETSLIP_TOTAL_ODDS",
  Set_BetSlip_Total_Stake: "SET_BETSLIP_TOTAL_STAKE",
  Set_BetSlip_Possible_Winnings: "SET_BETSLIP_POSSIBLE_WINNINGS",
  Set_Hide_Stake: "SET_HIDE_STAKE",
  Handle_Hide_Stake: "HANDLE_HIDE_STAKE",

  Set_BetSlip_Value_Change_Warning: "SET_BETSLIP_VALUE_CHANGE_WARNING",

  Set_Login_Error: "SET_LOGIN_ERROR",
  Clear_Login_Error: "CLEAR_LOGIN_ERROR",
  Clear_BetSlip_Success: "CLEAR_BETSLIP_SUCCESS",
  Place_Bet_Clear_Error_Message: "PLACE_BET_CLEAR_ERROR_MESSAGE",

  Update_Custom_Bet_Display_Odd: "UPDATE_CUSTOM_BET_DISPLAY_ODD",
  Update_BetBuilder_List_Done: "UPDATE_BETBUILDER_LIST_DONE",
  Set_BetBuilder_Total_Odds: "SET_BETBUILDER_TOTAL_ODDS",
  Set_BetBuilder_Possible_Winnings: "SET_BETBUILDER_POSSIBLE_WINNING",
  Clear_Bet_Builder: "CLEAR_BET_BUILDER",
  On_Bet_Builder_Amount_Change: "ON_BET_BUILDER_AMOUNT_CHANGE",
  Bet_Builder_Amount_Changed: "BET_BUILDER_AMOUNT_CHANGED",
  Place_Bet_Builder_Request: "PLACE_BET_BUILDER_REQUEST",
  Reset_Bet_Builder: "RESET_BET_BUILDER",
  Bet_Builder_Place_Bet_Error: "BET_BUILDER_PLACE_BET_ERROR",
  Validate_Single_Coupon: "VALIDATE_SINGLE_COUPON",
  Disable_Single_Coupoun: "DISABLE_SINGLE_COUPON",
  Set_BetSlip_Multiple_Disable: "SET_BETSLIP_MULTIPLE_DISABLE", 
};

export const ModalActionTypes = {
  Open_Modal_Request: "OPEN_MODAL_REQUEST",
  Open_Modal_Success: "OPEN_MODAL_SUCCESS",

  Close_Modal_Request: "CLOSE_MODAL_REQUEST",
  Close_Modal_Success: "CLOSE_MODAL_SUCCESS",
};

export const SlotsActionTypes = {
  Get_Slots_Games_Request: "GET_SLOTS_GAMES_REQUEST",
  Get_Slots_Games_Success: "GET_SLOTS_GAMES_SUCCESS",
  Get_Slots_Games_Error: "GET_SLOTS_GAMES_ERROR",

  Slots_Game_Connect_Request: "SLOTS_GAME_CONNECT_REQUEST",
  Slots_Game_Connect_Success: "SLOTS_GAME_CONNECT_SUCCESS",
  Slots_Game_Connect_Error: "SLOTS_GAME_CONNECT_ERROR",
  Slots_Game_Init: "SLOTS_GAME_INIT",
  Current_Slots_Game: "CURRENT_SLOTS_GAME",
  Set_Slots_Round_Finish: "SET_SLOTS_ROUND_FINISH",

  Get_Jackpot_Request: "GET_JACKPOT_REQUEST",
  Get_Jackpot_Success: "GET_JACKPOT_SUCCESS",
  Get_Jackpot_Error: "GET_JACKPOT_ERROR",

  Jackpot_Winning_Success: "JACKPOT_WINNING_SUCCESS",
  Jackpot_Winning_Approved: "JACKPOT_WINNING_APPROVED",
  Set_Jackpot_Won_Message: "SET_JACKPOT_WON_MESSAGE",
  Set_Is_Jackpot_Won: "SET_IS_JACKPOT_WON",

  Get_Slots_Bonus_Games_By_Condition_Id_Request:
    "GET_SLOTS_BONUS_GAMES_BY_CONDITION_ID_REQUEST",
  Get_Slots_Bonus_Games_By_Condition_Id_Success:
    "GET_SLOTS_BONUS_GAMES_BY_CONDITION_ID_SUCCESS",
  Get_Slots_Bonus_Games_By_Condition_Id_Error:
    "GET_SLOTS_BONUS_GAMES_BY_CONDITION_ID_ERROR",
  Set_Slots_Bonus_Games: "SET_SLOTS_BONUS_GAMES",
  Reset_Slots_Bonus_Games: "SET_SLOTS_BONUS_GAMES",
};
